import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Modal } from "antd";
import axios from "axios";
import "./InteractiveBlock.scss";

import InfoBox from "./InfoBox";
import utilsIndex from "../../utils/index";

import consultBtn from "../../images/checkAssistant/小工具01_右下角諮詢鈕.png";
import consultTitle from "../../images/checkAssistant/小工具02_彈跳視窗icon.png";

const InteractiveBlock = ({
  google_is_signed_in,
  // isFloatFormNotificationVisible, // 移除：不再使用滾動觸發
  checkListResult,
  checkListSummaries,
  setCheckListSummaries,
  checkListCompareResult,
  openSuccessModal,
  apiId,
  isProduction,
  currentContentIndex, // **使用 blockContentIndex**
  isLoading,
  setCurrentContentIndex,
  isInfoVisible,
  setIsInfoVisible,
  isPopupVisible,
  handleSubmit,
  setClearAutoShowTimer,
  // isBadgeDismissed, // 移除：不再使用 badge
  // setIsBadgeDismissed,
}) => {
  const [isBlockVisible, setIsBlockVisible] = useState(false); // 控制 interactive-block 顯示
  // const [isInfoVisible, setIsInfoVisible] = useState(false); // 控制 info-box 顯示
  // const [currentContentIndex, setCurrentContentIndex] = useState(0); // 控制 info-box 顯示的內容索引
  const [hasAutoShown, setHasAutoShown] = useState(false); // 控制是否已經自動顯示過一次（桌機和手機共用）
  // const [hasMobileAutoShown, setHasMobileAutoShown] = useState(false); // 控制手機版是否已經自動顯示一次
  // const [isBadgeDismissed, setIsBadgeDismissed] = useState(false); // 控制 badge 是否永久隱藏
  const [isMobile, setIsMobile] = useState(false); // 是否為手機版
  // const [isLoading, setIsLoading] = useState(false); // 控制 loading 顯示

  const autoShowTimer = useRef(null); // 儲存定時器的引用

  // **清除自動開啟 InfoBox 的計時器**
  const clearAutoShowTimer = () => {
    if (autoShowTimer.current) {
      clearTimeout(autoShowTimer.current);
      autoShowTimer.current = null;
    }
  };

  // **將清除計時器函式傳回給 App.js**
  useEffect(() => {
    if (setClearAutoShowTimer) {
      setClearAutoShowTimer(() => clearAutoShowTimer); // **正確傳遞函數**
    }
  }, []);

  // 偵測是否為手機裝置
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.matchMedia("(max-width: 576px)").matches);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    console.log("apiId = ", apiId);
    if (apiId) {
      setIsBlockVisible(true); // 顯示 chat-button
      // setIsInfoVisible(true);
    }
  }, [apiId]);

  // 移除：同步外部參數控制 info-box 的顯示 (滾軸滑動到 『一、市場表現綜合評比』 表單時顯示)
  // useEffect(() => {
  //   if (isFloatFormNotificationVisible) {
  //     // setIsBlockVisible(true); // 顯示 chat-button
  //     setIsInfoVisible(true);
  //   }
  // }, [isFloatFormNotificationVisible]);

  // 根據 currentContentIndex 動態控制 badge 的隱藏
  // useEffect(() => {
  //   if (currentContentIndex === 2) {
  //     setIsBadgeDismissed(true); // 當進入索引 2 時，永久隱藏 badge
  //   }
  // }, [currentContentIndex]);

  // 自動顯示 info-box（桌機和手機都只顯示一次，不再重複觸發）
  useEffect(() => {
    if (currentContentIndex === 1 && !isInfoVisible && !isPopupVisible && !hasAutoShown) {
      autoShowTimer.current = setTimeout(() => {
        setIsInfoVisible(true); // 15 秒後自動顯示 info-box
        setHasAutoShown(true); // 標記為已自動顯示過一次
      }, 15000);
    }

    return clearAutoShowTimer; // 清理定時器
  }, [
    currentContentIndex,
    isInfoVisible,
    hasAutoShown,
    isPopupVisible,
  ]);

  // **當 Popup 開啟時，確保 InfoBox 不會自動跳出**
  useEffect(() => {
    if (isPopupVisible) {
      setIsInfoVisible(false); // **確保 Popup 開啟時關閉 InfoBox**
      clearAutoShowTimer(); // **清除 15 秒後開啟的計時器**
      if (currentContentIndex === 2) {
        setCurrentContentIndex(1); // 將內容索引重置為 1
      }
    }
  }, [isPopupVisible]);

  // 切換 info-box 顯示狀態
  const toggleInfoBox = () => {
    utilsIndex.sendGAEvent("have_problem", {
      turing_01: "諮詢鈕",
      turing_02: "Check Assistant頁",
    });
    if (isInfoVisible && currentContentIndex === 2) {
      setCurrentContentIndex(1); // 將內容索引重置為 1
    }
    clearAutoShowTimer; // 清理定時器
    setIsInfoVisible(!isInfoVisible); // 切換顯示狀態
  };

  // 點擊 close-button 關閉 info-box（移除自動再次顯示的邏輯）
  const closeInfoBox = () => {
    clearAutoShowTimer; // 清理定時器
    setIsInfoVisible(false); // 隱藏 info-box

    // 移除：關閉後 15 秒自動再次顯示的邏輯
    // if (currentContentIndex === 0 && !hasAutoShown) {
    //   setTimeout(() => {
    //     setIsInfoVisible(true); // 15 秒後自動顯示
    //     setHasAutoShown(true); // 標記為已自動顯示
    //   }, 15000);
    // }

    // 如果當前內容為 2，關閉時重置為 1
    if (currentContentIndex === 2) {
      setCurrentContentIndex(1);
    }
  };

  // 切換到下一個內容
  const nextContent = () => {
    setCurrentContentIndex((prev) => (prev + 1) % 3);
  };

  // 控制互動區塊的顯示
  useEffect(() => {
    let blockTimer;

    if (google_is_signed_in) {
      // 5 秒後顯示 chat-button 和 info-box
      // blockTimer = setTimeout(() => {
      //   setIsBlockVisible(true); // 顯示 chat-button
      //   // setIsInfoVisible(true); // 顯示 info-box
      // }, 5000);
    } else {
      // 登出時隱藏所有區塊並重置狀態
      setIsBlockVisible(false);
      setIsInfoVisible(false);
      setHasAutoShown(false); // 重置自動顯示狀態
      // setHasMobileAutoShown(false); // 移除：已改用統一的 hasAutoShown
      // setIsBadgeDismissed(false); // 移除：不再使用 badge
    }

    return () => {
      clearTimeout(blockTimer);
    };
  }, [google_is_signed_in]);

  // console.log("hasAutoShown = ", hasAutoShown);

  return (
    <>
      {/* {true && ( */}
      {isBlockVisible && (
        <div className="interactive-block">
          {/* Info Box */}
          {isInfoVisible && (
            <InfoBox
              currentContentIndex={currentContentIndex}
              onClose={closeInfoBox}
              isLoading={isLoading}
              handleSubmit={handleSubmit}
              nextContent={() => {
                utilsIndex.sendGAEvent("reserve_service", {
                  turing_01: "諮詢鈕_優化視窗",
                  turing_02: "Check Assistant頁",
                });
                setCurrentContentIndex(1);
              }}
            />
          )}

          {/* Chat Button */}
          <div className="chat-button" onClick={toggleInfoBox}>
            <div className="icon">
              <img src={consultBtn} alt="Chat Icon" />
            </div>
            {/* 移除：不顯示 badge */}
            {/* {!isBadgeDismissed && <div className="badge">1</div>} */}
          </div>
        </div>
      )}
    </>
  );
};

export default InteractiveBlock;
